import React from "react";

import { ReactComponent as IconLike } from "../../../assets/svg/like.svg";
import { ReactComponent as IconChat } from "../../../assets/svg/chat.svg";
import { ReactComponent as IconArrow } from "../../../assets/svg/caret_down.svg";
import { IAnswer } from "../../../state";
import OneAnswerContents from "../../OneAnswerContents";
import FormReply from "../../../organisms/teacher/FormReply";
import FormComment from "../../../organisms/student/FormComment";

import styles from "./OneAnswerBox.module.scss";

export type OneAnswerBoxProps = {
  calling: boolean;
  currentTeacherID: number;
  name_opened: boolean;
  answer: IAnswer;
  isGroupAnswer?: boolean;
  handleComment: (
    content: string,
    answer_id: number,
    comment_id?: number,
  ) => void;
  handleToggleComment: (
    answer_id: number,
    comment_id: number,
    is_hidden: boolean,
  ) => void;
  handleDeleteComment: (answer_id: number, comment_id: number) => void;
};

export const OneAnswerBox: React.FC<OneAnswerBoxProps> = ({
  calling,
  currentTeacherID,
  name_opened,
  answer,
  isGroupAnswer = false,
  handleComment,
  handleToggleComment,
  handleDeleteComment,
}) => {
  const answerId = React.useMemo(
    () => (isGroupAnswer ? "groupAnswer" : "answer") + answer.id.toString(),
    [answer.id, isGroupAnswer],
  );

  const commentId = React.useMemo(
    () =>
      (isGroupAnswer ? "groupAnswerComment" : "answerComment") +
      answer.id.toString(),
    [answer.id, isGroupAnswer],
  );
  return (
    <div className={styles.content} key={answer.id}>
      <div className={styles.wrapper_content}>
        {answer.contents && <OneAnswerContents contents={answer.contents} />}
        <div className={styles.actions}>
          <div className={styles.actions__left}>
            <button>
              <IconLike />
              <span>
                {(!isGroupAnswer ? "生徒のいいね数：" : "") + answer.like_num}人
              </span>
            </button>
            <button
              data-bs-toggle="collapse"
              data-bs-target={`#${answerId}`}
              aria-expanded="false"
              aria-controls={answerId}
            >
              <IconChat />
              <span>コメントする</span>
            </button>
          </div>
        </div>
        <div className={`collapse ${styles.typingComment}`} id={answerId}>
          <FormComment
            answer={answer}
            replyAnswer={handleComment}
            calling={calling}
          />
        </div>
      </div>
      {answer.comments.length > 0 && (
        <div className={styles.wrapper_comment}>
          <div
            className={styles.toggleComment}
            data-bs-toggle="collapse"
            data-bs-target={`#${commentId}`}
            aria-expanded="false"
            aria-controls={commentId}
          >
            コメントを見る {answer.comments.length}件
            <IconArrow />
          </div>
          <div className={`collapse ${styles.comment}`} id={commentId}>
            {answer.comments.map(cmt => (
              <FormReply
                key={cmt.id}
                comment={cmt}
                answerId={answer.id}
                name_opened={name_opened}
                calling={calling}
                currentTeacherID={currentTeacherID}
                handleComment={handleComment}
                handleToggleComment={handleToggleComment}
                handleDeleteComment={handleDeleteComment}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default OneAnswerBox;
